module.exports = __webpack_public_path__ + "static/media/party.fd608bf2.jpg";